var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 289,
    height: 231,
    viewBox: "0 0 289 231",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.448 154H69.8585C65.5001 154 61.967 150.463 61.967 146.1C61.967 141.737 65.5001 138.2 69.8585 138.2H25.8915C21.5331 138.2 18 134.663 18 130.3C18 125.937 21.5331 122.4 25.8915 122.4H70.9858C75.3442 122.4 78.8774 118.863 78.8774 114.5C78.8774 110.137 75.3442 106.6 70.9858 106.6H42.8019C38.4435 106.6 34.9104 103.063 34.9104 98.7C34.9104 94.337 38.4435 90.8 42.8019 90.8H87.8962C83.5379 90.8 80.0047 87.263 80.0047 82.9C80.0047 78.537 83.5379 75 87.8962 75H152.156C156.514 75 160.047 78.537 160.047 82.9C160.047 87.263 156.514 90.8 152.156 90.8H224.307C228.665 90.8 232.198 94.337 232.198 98.7C232.198 103.063 228.665 106.6 224.307 106.6H249.108C253.467 106.6 257 110.137 257 114.5C257 118.863 253.467 122.4 249.108 122.4H227.689C223.33 122.4 219.797 125.937 219.797 130.3C219.797 134.663 223.33 138.2 227.689 138.2H234.453C238.811 138.2 242.344 141.737 242.344 146.1C242.344 150.463 238.811 154 234.453 154H175.83C175.25 154 174.684 153.937 174.139 153.818C173.594 153.937 173.029 154 172.448 154Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45 152.888C46.6569 152.888 48 151.545 48 149.888C48 148.231 46.6569 146.888 45 146.888C43.3431 146.888 42 148.231 42 149.888C42 151.545 43.3431 152.888 45 152.888Z",
    stroke: "#D0AB56",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.4946 80.2023L173.697 64.1606C175.672 63.8445 177.528 65.1889 177.845 67.1634C177.845 67.1673 177.846 67.1713 177.846 67.1752L187.649 129.731C187.957 131.702 186.614 133.551 184.644 133.867L84.4415 149.909C82.467 150.225 80.6101 148.88 80.294 146.906C80.2934 146.902 80.2927 146.898 80.2921 146.894L70.49 84.338C70.1811 82.367 71.5248 80.5177 73.4946 80.2023Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6578 148.882L85.8158 149.515C83.1767 149.95 80.6985 148.076 80.2804 145.33L71.1985 85.6593C70.7805 82.913 72.581 80.3341 75.2201 79.8991L171.984 63.9506C174.623 63.5158 177.102 65.3894 177.52 68.1357C177.927 70.8115 178.252 72.944 178.493 74.5332M179.183 79.0656C179.402 80.5051 179.594 81.7656 179.759 82.8472",
    stroke: "#D0AB56",
    strokeWidth: 3.01724,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.3516 82.9473L169.786 68.6684C171.756 68.3608 173.603 69.7032 173.92 71.6715L182.803 126.97C183.12 128.945 181.776 130.802 179.802 131.119C179.797 131.12 179.792 131.121 179.786 131.122L88.3519 145.401C86.3823 145.708 84.5346 144.366 84.2184 142.398L75.3354 87.0988C75.0183 85.1245 76.3617 83.2669 78.336 82.9497C78.3412 82.9489 78.3464 82.9481 78.3516 82.9473Z",
    fill: "#2C2C2C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M195.147 88.3276H100.405C97.739 88.3276 95.5776 90.489 95.5776 93.1552V151.69C95.5776 154.356 97.739 156.517 100.405 156.517H195.147C197.813 156.517 199.974 154.356 199.974 151.69V93.1552C199.974 90.489 197.813 88.3276 195.147 88.3276Z",
    fill: "#333333",
    stroke: "url(#paint0_linear_160_887)",
    strokeWidth: 3.01724
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M198.466 102.509H97.0864V119.405H198.466V102.509Z",
    fill: "#2C2C2C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M198.276 102.509H118.814M191.034 118.198H95.8833M139.007 141.129H104.842M112.729 102.509H104.043",
    stroke: "#D0AB56",
    strokeWidth: 3.01724,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M201 75C203.209 75 205 73.2091 205 71C205 68.7909 203.209 67 201 67C198.791 67 197 68.7909 197 71C197 73.2091 198.791 75 201 75Z",
    stroke: "#D0AB56",
    strokeWidth: 2.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M188 63L194 57.8769L188 53",
    stroke: "#D0AB56",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M212 63L206 57.8769L212 53",
    stroke: "#D0AB56",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M45 174C46.6569 174 48 172.657 48 171C48 169.343 46.6569 168 45 168C43.3431 168 42 169.343 42 171C42 172.657 43.3431 174 45 174Z",
    fill: "#D0AB56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M59 165L65 171M65.0912 165L59.0912 171L65.0912 165Z",
    stroke: "url(#paint1_linear_160_887)",
    strokeWidth: 1.79464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 255.931,
    cy: 146.444,
    r: 8.06944,
    fill: "#333333"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_160_887",
    x1: 147.776,
    y1: 88.3276,
    x2: 147.776,
    y2: 156.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E8852B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0AB56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_160_887",
    x1: 62.0456,
    y1: 165,
    x2: 62.0456,
    y2: 171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E8852B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0AB56"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.8da6648da6e69d26e0eee6410ff0a321.svg";
export { ForwardRef as ReactComponent };